import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const PrivacySettings = ({ isOpen, onClose }) => {
  const [settings, setSettings] = useState({
    shareCurrentMood: true,
    shareEnergyLevel: true,
    shareEncounterTypes: false,
    shareEmotionalState: false,
    allowAIMatching: true,
    notifyOnMatch: true
  });

  const handleSettingChange = (key) => {
    setSettings(prev => ({
      ...prev,
      [key]: !prev?.[key]
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal bg-background/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-lg shadow-therapeutic-lg border border-border">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Privacy Settings
          </h3>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-therapeutic"
          >
            <Icon name="X" size={20} color="currentColor" />
          </button>
        </div>

        <div className="p-4 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-foreground">
              Share with Partner
            </h4>
            <Checkbox
              label="Current Mood Level"
              description="Allow partner to see your overall mood status"
              checked={settings?.shareCurrentMood}
              onChange={() => handleSettingChange('shareCurrentMood')}
            />
            <Checkbox
              label="Energy Level"
              description="Share your current energy rating"
              checked={settings?.shareEnergyLevel}
              onChange={() => handleSettingChange('shareEnergyLevel')}
            />
            <Checkbox
              label="Preferred Encounter Types"
              description="Let partner see your selected preferences"
              checked={settings?.shareEncounterTypes}
              onChange={() => handleSettingChange('shareEncounterTypes')}
            />
            <Checkbox
              label="Emotional State"
              description="Share how you're feeling emotionally"
              checked={settings?.shareEmotionalState}
              onChange={() => handleSettingChange('shareEmotionalState')}
            />
          </div>

          <div className="pt-4 border-t border-border space-y-3">
            <h4 className="text-sm font-medium text-foreground">
              AI Matching
            </h4>
            <Checkbox
              label="Enable AI Compatibility Matching"
              description="Allow AI to analyze and suggest optimal timing"
              checked={settings?.allowAIMatching}
              onChange={() => handleSettingChange('allowAIMatching')}
            />
            <Checkbox
              label="Notify on High Compatibility"
              description="Receive alerts when moods align well"
              checked={settings?.notifyOnMatch}
              onChange={() => handleSettingChange('notifyOnMatch')}
            />
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex items-start space-x-2 p-3 rounded-md bg-muted">
              <Icon name="Lock" size={16} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-muted-foreground">
                Your detailed preferences and history remain private. Only selected information is shared with your partner through AI mediation.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end space-x-3 p-4 border-t border-border">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-border text-foreground hover:bg-muted transition-therapeutic text-sm font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-therapeutic text-sm font-medium"
          >
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;